import { cn } from '@my/ui';

/**
 * The "Integration" pill the Bookings cockpit shows top right of its panel:
 * On books a linked crossing through My.Ferry as well as the TMS; Off keeps
 * the booking a TMS one. Same look everywhere it appears.
 */
export function IntegrationSwitch({
  on,
  disabled,
  onToggle,
  dark,
}: {
  on: boolean;
  disabled?: boolean;
  onToggle: () => void;
  /** On a dark bar (the cockpit header) the On/Off reads white. */
  dark?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      className="flex items-center gap-1.5 disabled:opacity-50"
      aria-pressed={on}
      aria-label="Book through the ferry service"
      title={on ? 'Booked at the carrier through My.Ferry' : 'TMS booking only'}
    >
      <span className="text-[10px] uppercase tracking-wide text-slate-400">Integration</span>
      <span
        className={cn(
          'relative inline-flex h-4 w-7 items-center rounded-full transition-colors',
          on ? 'bg-emerald-500' : 'bg-slate-400',
        )}
      >
        <span
          className={cn(
            'inline-block h-3 w-3 transform rounded-full bg-white transition-transform',
            on ? 'translate-x-3.5' : 'translate-x-0.5',
          )}
        />
      </span>
      <span className={cn('text-[10px] font-medium', dark ? 'text-white' : 'text-slate-600')}>
        {on ? 'On' : 'Off'}
      </span>
    </button>
  );
}
